<template>
    <b-modal
        id="show-personalgoal-tasks-modal"
        v-model="modal"
        modal-class="apprentice-default-modal show-personalgoal-tasks-modal"
        :title="`Leerdoel: ${personalGoal.name}`"
        :ok-title="$t('common.save')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        @ok="onOk">
        <div
            class="view-personal-goal-tasks-edit tasks"
            v-if="tasks.length">
            <h3 class="title">Taken</h3>
            <div
                class="task"
                v-for="task in tasks"
                :class="task.checked && 'checked'">
                <b-form-checkbox
                    v-model="task.checked"
                    :value="1"
                    :unchecked-value="0">
                    {{ task.name }}
                </b-form-checkbox>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-personal-goal-tasks-show-modal-component',
    props: {},
    data() {
        return {
            modal: false,
            personalGoal: '',
            tasks: [],
        };
    },

    methods: {
        show(goal) {
            this.personalGoal = goal;
            this.tasks = this.personalGoal.tasks.length ? [...this.personalGoal.tasks] : [];
            this.modal = true;
        },

        onOk() {
            const data = {
                tasks: this.tasks.map((task) => {
                    return {
                        task_id: task.id,
                        checked: task.checked,
                    };
                }),
            };

            this.alert.saving();
            this.axios.post(this.routes.personalGoalTaskStatusUpdate(), data).then(
                (response) => {
                    for (const [index, task] of this.personalGoal.tasks.entries()) {
                        task.update({ checked: response.data[index].checked });
                    }
                    this.$emit('update-chart', this.personalGoal.id);
                    this.alert.success();
                },
                (error) => {
                    error = true;
                },
            );
        },
    },
};
</script>

<style scoped>
.tasks .title {
    margin-bottom: 15px;
}

.task {
    font-size: 0.875rem;
}

.task.checked >>> .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #c3c3c3;
    border-color: #c3c3c3;
}

.task.checked >>> label {
    font-weight: 500;
    color: #757575;
    text-decoration: line-through;
    text-decoration-color: #757575;
    text-decoration-thickness: 2px;
}
</style>
